module.exports = __webpack_public_path__ + "img/hk-bottom.75587715.png";